"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckBoxButton = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../../utils/classFunctions");
require("./index.scss");
const className = 'checkbox-button';
const CheckBoxButton = (props) => {
    const { text, additionClassName, additionTextClassName, color = 'green', ...restProps } = props;
    const containerClassNames = (0, classFunctions_1.getClassNames)(`${className}__container`, [
        color,
        restProps.checked ? 'checked' : undefined,
        restProps.disabled ? 'disabled' : undefined,
    ]);
    return (react_1.default.createElement("div", { className: `${className} ${additionClassName !== null && additionClassName !== void 0 ? additionClassName : ''}` },
        react_1.default.createElement("label", { className: containerClassNames },
            react_1.default.createElement("input", { className: `${className}__value`, type: 'checkbox', ...restProps }),
            react_1.default.createElement("span", { className: `${className}__text ${additionTextClassName !== null && additionTextClassName !== void 0 ? additionTextClassName : ''}` },
                " ",
                text,
                " "))));
};
exports.CheckBoxButton = CheckBoxButton;
//# sourceMappingURL=index.js.map